export const enX = {
  footer: { privacy: "Privacy Policy" },
  join: {
    ph: { region: "Region / Prefecture" },
    privacy: "I have read and agree to the",
    privacyLink: "Privacy Policy",
    privacySuffix: ", including international processing of my information.",
  },
  database: {
    dirKicker: "Public Directory",
    dirTitle: "Published with consent",
    dirEmpty: "No public entries yet. This directory grows as registered growers and organizations consent to be listed.",
  },
  verify: {
    checking: "Confirming your registration…",
    okTitle: "Registration confirmed",
    okText: "Thank you — your registration with the World Rhubarb Association is now complete. A welcome email with the Database survey link is on its way to your inbox.",
    errTitle: "Link invalid or already used",
    errText: "This confirmation link is invalid or has already been used. If you haven't received a confirmation email, please register again from the form.",
    home: "Back to the site",
  },
  survey: {
    kicker: "Global Rhubarb Database",
    title: "Database Survey",
    intro: "Thank you for registering with the World Rhubarb Association. This survey helps build the Global Rhubarb Database — a verified, consent-based record of the world's rhubarb industry. Answering is optional and does not affect your registration.",
    verifyTitle: "Your registration",
    refPh: "Registration reference (e.g. WRA-AB12CD34) *",
    emailPh: "Registration email *",
    aboutTitle: "About your farm or organization",
    farmPh: "Farm / Organization name *",
    countryPh: "Country *",
    regionPh: "Region / State / Prefecture",
    websitePh: "Website / Social media (optional)",
    orgTypePh: "Type of organization *",
    orgTypes: ["Farm / Grower", "Cooperative", "Food company", "Restaurant", "Retailer", "Research institution", "Organization", "Individual / Enthusiast", "Other"],
    rhubarbTitle: "Your rhubarb",
    varietiesPh: "Rhubarb varieties you grow or work with",
    areaPh: "Approximate cultivation area (e.g. 2 ha)",
    productionPh: "Approximate annual production (e.g. 5 t)",
    consentTitle: "Public display consent",
    consentAgree: "I agree to have my selected information publicly displayed in the Global Rhubarb Database.",
    consentDecline: "I do not want my information to be publicly displayed.",
    fieldsLabel: "Choose what may be published:",
    fieldLabels: {
      farm_name: "Farm / Organization name", country: "Country", region: "Region",
      website: "Website / Social media", org_type: "Type of organization", varieties: "Rhubarb varieties",
      cultivation_area: "Cultivation area", annual_production: "Annual production",
    },
    noteNoConsent: "You can register and answer the survey without agreeing to public display. Your answers will still support WRA's research and will never be published.",
    crossBorder: "I understand that my information may be processed by service providers and servers located outside my country (including overseas hosting and email delivery services), as described in the Privacy Policy.",
    privateNote: "Your email address, and any field you do not select, are never published. You may request a correction, update, removal of your public listing, or deletion of your data at any time via the contact form.",
    submit: "Submit survey",
    submitting: "Submitting…",
    thanks: "Survey received",
    successConsent: "Thank you. Your selected information will be reviewed and published in the Global Rhubarb Database.",
    successNoConsent: "Thank you. Your answers were recorded and will remain private.",
    errNotFound: "We could not find a registration with that reference and email. Please check both and try again.",
    toastOk: "Survey submitted.",
    toastErr: "Submission failed. Please try again.",
    editNote: "Already answered? Submitting again updates your previous answers.",
  },
  privacy: {
    kicker: "Privacy Policy",
    titleA: "How we handle ", titleAccent: "your information.",
    updated: "Last updated: August 2026",
    intro: "The World Rhubarb Association (WRA) is a voluntary international initiative founded in 2026. This policy explains what personal information we collect, why we collect it, and how it is protected.",
    sections: [
      { h: "Information we collect", body: [
        "Through the registration form: your name, farm or organization name, country, region, email address and member type.",
        "Through the optional Database survey: website or social media links, type of organization, rhubarb varieties, approximate cultivation area and approximate annual production.",
        "We do not collect personal information that is not needed for registration or for building the Database (data minimization).",
      ]},
      { h: "Why we collect it", body: [
        "To build and operate the Global Rhubarb Database.",
        "To contact you from the World Rhubarb Association — for example your welcome email, the survey invitation and network updates.",
        "To manage membership and respond to inquiries.",
      ]},
      { h: "Public and non-public information", body: [
        "Never published: your email address, phone number, personal address and any other personal contact details.",
        "Published only with your explicit consent, and only the items you select: farm or organization name, country, region, website or social media, type of organization, rhubarb varieties, approximate cultivation area and approximate annual production.",
        "You can register and answer the survey without agreeing to any publication.",
      ]},
      { h: "Service providers", body: [
        "To manage and operate the Database and to deliver emails, we may use service providers (such as hosting and email delivery services) within the necessary scope. Providers are engaged under appropriate data-handling terms.",
      ]},
      { h: "International processing", body: [
        "WRA serves growers and stakeholders worldwide. Your information may be processed by services and servers located outside your country, which may constitute a cross-border transfer under Japan's Act on the Protection of Personal Information (APPI) and similar regulations.",
        "By submitting a form you acknowledge this international processing. Where required by law, we will obtain separate consent before providing personal data to an overseas third party.",
      ]},
      { h: "Data management", body: [
        "Personal information is stored securely. Access is restricted to the WRA founding team, and the administration area is password-protected.",
      ]},
      { h: "Correction, update and deletion", body: [
        "You may request a correction of your information, an update, removal of your public listing, or deletion of your data at any time through the contact form on the main page. We respond promptly after verifying your identity.",
      ]},
      { h: "Contact", body: [
        "For any privacy question or request, please use the contact form on the main page.",
      ]},
    ],
  },
};
